import $ from "jquery";
window.$ = window.jQuery = $;

(function($, window, document) {

	"use strict";
    
	/**
	 * Main theme object.
	*/
	var TLS_Product = function () {
        var self = this;
		var that = this;

        this.boot_ui = function () 
		{
			self.number_inputs();
			self.loop_link_detail_product();
			self.add_to_cart_product();
			self.variations();

			$(document.body).on("woosq_loaded", function (event, id) {
        		console.log("woosq_loaded " + id);
        		self.add_to_cart_product();

      		});
		};

		this.variations = function() 
		{
			// clones select options for each product attribute
            var clone = $(".single-product div.product table.variations select:not([name='attribute_pa_durata'])").clone(true,true);

                // adds a "data-parent-id" attribute to each select option
                $(".single-product div.product table.variations select:not([name='attribute_pa_durata']) option").each(function(){
                    $(this).attr('data-parent-id',$(this).parent().attr('id'));
                });

                // converts select options to div
                $(".single-product div.product:not(.product-type-bundle) table.variations select:not([name='attribute_pa_durata']) option").unwrap().each(function(){
                    if ( $(this).val() == '' ) {
                        $(this).remove();
                        return true;
                    }
                    var option = $('<div class="custom_option is-visible" data-parent-id="'+$(this).data('parent-id')+'" data-value="'+$(this).val()+'">'+$(this).text()+'</div>');
                    $(this).replaceWith(option);
                });
                
                // reinsert the clone of the select options of the attributes in the page that were removed by "unwrap()"
                $(clone).insertBefore('.single-product div.product:not(.product-type-bundle) table.variations .reset_variations').hide();

                // when a user clicks on a div it adds the "selected" attribute to the respective select option
                $(document).on('click', '.custom_option', function(){
                    var parentID = $(this).data('parent-id');
                    if ( $(this).hasClass('on') ) {
                        $(this).removeClass('on');
                        $(".single-product div.product table.variations select#"+parentID).val('').trigger("change");
                    } else {
                        $('.custom_option[data-parent-id='+parentID+']').removeClass('on');
                        $(this).addClass('on');
                        $(".single-product div.product table.variations select#"+parentID).val($(this).data("value")).trigger("change");
                    }
                    
                });

                // if a select option is already selected, it adds the "on" attribute to the respective div
                $(".single-product div.product table.variations select:not([name='attribute_pa_durata'])").each(function(){
                    if ( $(this).find("option:selected").val() ) {
                        var id = $(this).attr('id');
                        $('.custom_option[data-parent-id='+id+']').removeClass('on');
                        var value = $(this).find("option:selected").val();
                        $('.custom_option[data-parent-id='+id+'][data-value='+value+']').addClass('on');
                    }
                });

                // when the select options change based on the ones selected, it shows or hides the respective divs
                $('body').on('check_variations', function(){
                    $('div.custom_option').removeClass('is-visible');
                    $('.single-product div.product:not(.product-type-bundle) table.variations select').each(function(){
                        var attrID = $(this).attr("id");
                        $(this).find('option').each(function(){
                            if ( $(this).val() == '' ) {
                                return;
                            }
                            $('div[data-parent-id="'+attrID+'"][data-value="'+$(this).val()+'"]').addClass('is-visible');
                        });
                    });
                });

				$('body').on('click', '.reset_variations', function(){
					$('div.custom_option').removeClass('on');
				});
		};

		this.add_to_cart_product = function () 
		{

			$(document.body).on("tls_after_add_to_cart", function () {
				if ($("[name='update_cart']").length > 0) {
					// setTimeout(() => {
					// 	$("[name='update_cart']").trigger("click");
					// }, 500);
					$('.woocommerce-notices-wrapper').empty();
				}
			});

			// add to cart product card : simple / bundle (senza selezioni)
			$(".card--product .single_add_to_cart_button").on("click", function (e) {
				e.preventDefault();

				var $thisbutton = $(this),
					subito = $thisbutton.hasClass("now"),
					product_id = $thisbutton.data("id"),
					product_qty = 1,
					data = {
						action: "tls_ajax_add_to_cart",
						product_id: product_id,
						quantity: product_qty,
					};
				
				if(!subito)
					$(document.body).trigger("adding_to_cart", [$thisbutton, data]);

				$.ajax({
					type: "post",
					url: window.tls_main_data.ajax_url,
					data: data,
					beforeSend: function (response) {
						$thisbutton.removeClass("added").addClass("loading");
					},
					complete: function (response) {
						$thisbutton.addClass("added").removeClass("loading");
					},
					success: function (response) {
						if (response.error & response.product_url) {
						window.location = response.product_url;
						return;
						} else {
							if (!subito){

								$(document.body).trigger("added_to_cart", [
									response.fragments,
									response.cart_hash,
									$thisbutton,
								]);

								$(document.body).trigger("tls_after_add_to_cart");

							} else {
								window.location.href = tls_main_data.checkout_url;
							}
						}
					},
					error: function (response) {
						console.log("error", response);
					},
				});

				// check GTM
        		if (typeof gtm4wp_datalayer_name == "undefined") return false;

				let product_wrapper = $thisbutton.closest(".card--product");

				
				const product_data = product_wrapper.find(".gtm4wp_productdata").data("gtm4wp_product_data");

				if(typeof product_data === 'undefined')
					return;
				if(typeof product_data === 'string')
					product_data = JSON.parse(product_data);
				
				product_data.quantity = product_qty;

				// fix prezzo bundle
				if (product_data.price === 0) {
					product_data.price = parseFloat(
						product_wrapper.find(".price .amount bdi").text().replace(",", ".")
					).toFixed(2);
				}

				let total_price = product_data.price * product_qty;

				console.log("product_data", product_data);
				

				// fire ga4 version
				gtm4wp_push_ecommerce("add_to_cart", [product_data], {
				currency: gtm4wp_currency, // ga4 version
				value: total_price,
				});

			});

			$(
        ".summary form.cart:not(.gift-cards_form) .single_add_to_cart_button"
      ).on("click", function (e) {
        e.preventDefault();

        var $form = $(this).closest("form");

        $form.trigger("submit", [$(this).hasClass("buy-now")]);
      });
		// add to cart form quickview / product page : not gift card
		$(".summary form.cart:not(.gift-cards_form)").on(
        "submit",
        function (e, buy_now) {
          e.preventDefault();

          // console.log($(this).serializeArray());

          // console.log('buy_now',buy_now);

          // return false;

          var $form = $(this),
            $thisbutton = $(this).find(".single_add_to_cart_button"),
            id = $thisbutton.val(),
            product_qty = $form.find("input[name=quantity]").val() || 1,
            product_id = $form.find("input[name=product_id]").val() || id,
            variation_id = $form.find("input[name=variation_id]").val() || 0,
            centro = $form.find("select[name=centro").val() || 0,
            data = {
              action: "tls_ajax_add_to_cart",
              product_id: product_id,
              product_sku: "",
              quantity: product_qty,
              variation_id: variation_id,
              centro: centro,
            };

          if ($form.find("select[name=centro").length > 0 && centro == 0) {
            return false;
          }

          // if button è buy-now non aprire il cart
          if (!buy_now) {
            $(document.body).trigger("adding_to_cart", [$thisbutton, data]);
          }

          $.ajax({
            type: "post",
            url: window.tls_main_data.ajax_url,
            data: data,
            beforeSend: function (response) {
              $thisbutton.removeClass("added").addClass("loading");
            },
            complete: function (response) {
              $thisbutton.addClass("added").removeClass("loading");
            },
            success: function (response) {
              if (response.error & response.product_url) {
                window.location = response.product_url;
                return;
              } else {
                if (buy_now) {
                  window.location.href = tls_main_data.checkout_url;
                } else {
                  $(document.body).trigger("added_to_cart", [
                    response.fragments,
                    response.cart_hash,
                    $thisbutton,
                  ]);

                  $(document.body).trigger("tls_after_add_to_cart");
                }
              }
            },
            error: function (response) {
              console.log("error", response);
            },
          });

          // return false;

          // check GTM
          if (typeof gtm4wp_datalayer_name == "undefined") return false;

          const product_form = $form;
          if (!product_form) {
            return true;
          }

          let product_variant_id = product_form.find(
            "input[name=variation_id]"
          );
          let product_is_grouped = product_form.hasClass("grouped_form");
          let product_is_bundle = product_form.hasClass("bundle_form");

          console.log("product_is_bundle", product_is_bundle);
          console.log("product_is_grouped", product_is_grouped);

          // const productdata = {};
          const product_data = JSON.parse(
            product_form.find("input[name=gtm4wp_product_data]").val()
          );

          if (product_variant_id.length > 0 && product_variant_id.val() > 0) {
            if (
              product_form.find("input[name=gtm4wp_product_data]").length > 0
            ) {
              let variations_value = [];
              product_form.find("[name^='attribute_']").each(function () {
                const value = $(this).val();

                if (value) {
                  variations_value.push(value);
                }
              });

              product_data.id = product_variant_id.val();
              product_data.item_id = product_variant_id.val();

              let price = parseFloat(
                product_form
                  .find("div.woocommerce-variation-price .amount bdi")
                  .text()
                  .replace(",", ".")
              ).toFixed(2);

              product_data.variant = variations_value.join(",");

              console.log("product_data", product_data);

              let total_price = price * product_qty;

              // fire ga4 version
              gtm4wp_push_ecommerce("add_to_cart", [product_data], {
                currency: gtm4wp_currency, // ga4 version
                value: total_price,
              });
            }
          } else if (product_is_grouped) {
          } else if (product_is_bundle) {
            if (
              product_form.find("input[name=gtm4wp_product_data]").length > 0
            ) {
              let total_price = 0;

              let bundle_quantity =
                $form
                  .find(".simple_wrap .bundle_wrap input[name=quantity]")
                  .val() || 1;

              const bundle_data = $form
                .find(".bundle_data")
                .data("bundle_form_data");

              console.log("bundle_data", bundle_data);

              total_price += bundle_data.base_price;

              $.each(bundle_data.prices, function (index, value) {
                total_price += value;
              });

              total_price = total_price * bundle_quantity;

              product_data.price = total_price;
              product_data.quantity = bundle_quantity;

              console.log("product_data bundle", product_data);

              // fire ga4 version
              gtm4wp_push_ecommerce("add_to_cart", [product_data], {
                currency: gtm4wp_currency, // ga4 version
                value: total_price,
              });
            }
          } else {
            const product_id_el = gtm4wp_use_sku_instead
              ? product_form.querySelector("[name=gtm4wp_sku]")
              : product_form.querySelector("[name=gtm4wp_id]");
            const product_data = {
              id: product_id_el && product_id_el.value,
              name:
                product_form.querySelector("[name=gtm4wp_name]") &&
                product_form.querySelector("[name=gtm4wp_name]").value,
              price:
                product_form.querySelector("[name=gtm4wp_price]") &&
                product_form.querySelector("[name=gtm4wp_price]").value,
              category:
                product_form.querySelector("[name=gtm4wp_category]") &&
                product_form.querySelector("[name=gtm4wp_category]").value,
              quantity:
                product_form.querySelector("[name=quantity]") &&
                product_form.querySelector("[name=quantity]").value,
              stocklevel:
                product_form.querySelector("[name=gtm4wp_stocklevel]") &&
                product_form.querySelector("[name=gtm4wp_stocklevel]").value,
              brand:
                product_form.querySelector("[name=gtm4wp_brand]") &&
                product_form.querySelector("[name=gtm4wp_brand]").value,
            };

            // fire ga4 version
            window[gtm4wp_datalayer_name].push({
              event: "add_to_cart",
              ecommerce: {
                currency: gtm4wp_currency,
                value: product_data.price * product_data.quantity,
                items: [gtm4wp_map_eec_to_ga4(product_data)],
              },
            });
          }

          return false;
        }
      );
		};

		this.loop_link_detail_product = function () 
		{
			$(".container-fluid, .container, .container-big").on("click", "li:not(.product-bundlekit-list) .card--product img", function(e) {
                e.preventDefault();       
				var url = $(this).parent().find(".woocommerce-loop-product__link").attr("href");
				if(typeof url !== "undefined")
                	window.location.href = url;
            });
		};

        this.number_inputs = function () 
		{
			$( document ).on("click", '.quantity input.minus', function () {

				if( $(this).parents('.auction_form').length == 0 ) {
					that.$qty = $(this).closest('.quantity').find('.qty');
					that.setStep();
					that.updateState();
					that.decrement($(this));
				}
			});

			$( document ).on("click", '.quantity input.plus', function () {
			
                if( $(this).parents('.auction_form').length == 0 ) {

                    that.$qty = $(this).closest('.quantity').find('.qty');
                    that.setStep();
                    that.updateState();
                    that.increment($(this));
                }
            });
        };

		this.checkMiniCart = function(el) 
		{
			return ( el.parents('.woocommerce-mini-cart').length > 0 ) ? true : false;
		};

		this.checkCart = function(el)
		{
			return el.parents(".woocommerce-cart-form").length > 0 ? true : false;
		}

		this.updateState = function(el) 
		{
			// Get key.
			var key = 0;

			if( true === that.checkMiniCart(that.$qty) ) {
				var matches = that.$qty.attr('name').match(/cart\[(\w+)\]/);
				key = matches[1];
			}

			

			// Store current.
			var currentVal = parseFloat(that.$qty.val());

			if (!currentVal || currentVal === '' || currentVal === 'NaN') {
				currentVal = 0;
			}

			// Max/Min vals.
			var max = parseFloat(that.$qty.attr('max'));
			var min = parseFloat(that.$qty.attr('min'));

			if (max === '' || max === 'NaN' || isNaN(max) ) {
				max = '';
			}

			if (min === '' || min === 'NaN' || isNaN(min) ) {
				min = 0;
			}

			// Push to state.
			that.state = {
				currentVal: currentVal,
				max: max,
				min: min,
				key: key
			};

			if (true === that.checkCart(that.$qty)) {
				// alert('update cart');
				setTimeout(() => {
					$("[name='update_cart']").trigger("click");
					
				}, 500);
			}

		};

		this.setStep = function() 
		{
			if( that.$qty.is('[step]') ) {
				var step = parseInt(that.$qty.attr('step'));

				if( !isNaN(step) && step != '' && step != 0) {
					that.step = step;
				}

			}
		};

		this.increment = function() 
		{
			if (that.state.max && (that.state.max == that.state.currentVal || that.state.currentVal > that.state.max)) {
				that.$qty.val(that.state.max);
			} else {
				that.$qty.val(that.state.currentVal + parseFloat(that.step));
			}

			that.$qty.trigger('change');
		};

		this.decrement = function() 
		{
			if (that.state.min && (that.state.min == that.state.currentVal || that.state.currentVal < that.state.min)) {
				that.$qty.val(0);
				that.state.removeFlag = true;

			} else if (that.state.currentVal > 0) {
				that.$qty.val(that.state.currentVal - parseFloat(that.step));
			}

			that.$qty.trigger('change');
		};
        
		this.getQueryParams = function(name, url)
		{
			if (!url) url = window.location.href;
			name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
			var regexS = "[\\?&]" + name + "=([^&#]*)";
			var regex = new RegExp(regexS);
			var results = regex.exec(url);
			return results == null ? null : results[1];
		};

		this.initGallery = function(element) 
		{
			element.preventDefault();
			const link = element.currentTarget,
			gallery = link.closest('div.gallery');
			self.galleryShortcode(gallery,link);
		}

		let parseThumbnailElements = function (link, id) 
		{
			let elements,
				galleryItems = [],
				index = 1;

			const element = document.querySelector(`#${id}`);

			elements = element.querySelectorAll('a');
			
			for (let i = 0; i < elements.length; i++) {
				let element = elements[i];
				
				// Only use image if it was not added already
				let useImage = true;
				let linkHref = element.getAttribute('href');


				const img = element.querySelector('img')
				
				const w = img.getAttribute('width')
				const h = img.getAttribute('height')
				

				if (useImage) {
					let caption = null;
					let title = null;
					let tabindex = element.getAttribute('tabindex');

					if (tabindex == null || tabindex == -1) {
						tabindex = 0;
					}

					caption = element.getAttribute('data-caption');

					// Attribute "aria-describedby" in the <a> element contains the ID of another element with the caption
					if (caption == null && element.firstElementChild) {
						let describedby = element.firstElementChild.getAttribute('aria-describedby');
						if (describedby != null) {
							let description = document.getElementById(describedby);
							if (description != null) caption = description.innerHTML;
						}
					}

					// Other variations
					if (caption == null) {
						let nextElement = element.nextElementSibling;
						let parentElement = element.parentElement.nextElementSibling;
						let parentElement2 = element.parentElement.parentElement.nextElementSibling;
						let parentElement3 = element.parentElement.parentElement.parentElement.nextElementSibling;

						if (nextElement != null) {
							if (nextElement.className === '.wp-caption-text') {
								caption = nextElement.innerHTML;
							} else if (nextElement && nextElement.nodeName === "FIGCAPTION") {
								caption = nextElement.innerHTML;
							}
						} else if (parentElement != null) {
							if (parentElement.className === '.wp-caption-text') {
								caption = parentElement.innerHTML;
							} else if (parentElement.className === '.gallery-caption') {
								caption = parentElement.innerHTML;
							} else if (parentElement.nextElementSibling && parentElement.nextElementSibling.nodeName === "FIGCAPTION") {
								caption = parentElement.nextElementSibling.innerHTML;
							}
						} else if (parentElement2 && parentElement2.nodeName === "FIGCAPTION") {
							caption = parentElement2.innerHTML;
						} else if (parentElement3 && parentElement3.nodeName === "FIGCAPTION") {
							// This variant is used by Gutenberg gallery blocks
							caption = parentElement3.innerHTML;
						}
					}

					if (caption == null) {
						caption = element.getAttribute('title');
					}

					// Build complete caption based on selected elements
					title = '';

					
					
					const msrc = element.getAttribute('href');
					
					
					galleryItems.push({
						src: element.getAttribute('href'),
						msrc: msrc,
						w: w,
						h: h,
						title: title,
						exif: '',
						getThumbBoundsFn: false,
						showHideOpacity: true,
						el: element,
						tabindex: tabindex
					});
				}
			}

			// Sort items by tabindex
			galleryItems.sort(function (a, b) {
				let indexa = parseInt(a.tabindex);
				let indexb = parseInt(b.tabindex);
				if (indexa > indexb) {
					return 1;
				}
				if (indexa < indexb) {
					return -1;
				}
				return 0;
			});

			// Determine current selected item
			if (link != null) {
				for (let i = 0; i < galleryItems.length; i++) {
					if (galleryItems[i].el.getAttribute('href') === link.getAttribute('href')) {
						index = i;
					}
				}
			}

			return [galleryItems, parseInt(index, 10)];
		};

		this.galleryShortcode = function(galleryWrapper,element) 
		{
			let id,
				pswpElement = document.querySelector('.pswp'),
				options,
				items,
				index;

			id = galleryWrapper.getAttribute('id');

			items = parseThumbnailElements(element, id);

			index = items[1];
			
			items = items[0];

			options = {
				index: index,
				getThumbBoundsFn: false,
				showHideOpacity: true,
				loop: true,
				tapToToggleControls: true,
				clickToCloseNonZoomable: false,
			};

			if (id != null) {
				options.galleryUID = id;
			}

			options.shareEl = false;
			options.closeOnScroll = false;
			options.zoomOnScroll = false;
			options.switchOnScroll = false;
			options.closeOnVerticalDrag = false;
			options.history = false;
			options.counterEl = false;
			options.fullscreenEl = true;
			options.zoomEl = true;
			options.captionEl = false;
			options.loop = true;
			options.pinchToClose = false;
			options.tapToToggleControls = true;
			options.desktopSlider = true;
			options.spacing = 10;
			options.timeToIdle = 100;
			options.barsSize = {top: 0, bottom: 0};

			// Initializes and opens PhotoSwipe
			var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
			gallery.init();
		};

		this.check_centro_simple = function() {
			const $form = $('form.cart.cart-centro-select:not(.variations_form)');
			if(!$form.length)
				return;

			const centro = $('#centro_variazione');
			if(!$('#centro_variazione').length)
				return;

			console.log('trigger check_centro_simple');
			
			if(centro.val() == '')
			{
				$form
					.find( '.single_add_to_cart_button' )
					.addClass( 'disabled' );
				$form
					.find( '.wl-add-to' )
					.addClass( 'disabled' );
			}
			else
			{
				$form
					.find( '.single_add_to_cart_button' )
					.removeClass( 'disabled' );
				$form
					.find( '.wl-add-to' )
					.removeClass( 'disabled' );
			}
		};

		this.deselect_centro = function(){
			const $form = $('form.cart.cart-centro-select');
			if(!$form.length)
				return;

			const centro = $('#centro_variazione');
			if(!$('#centro_variazione').length)
				return;

			centro.find("option:selected").removeAttr("selected");
		};

		this.check_centro_variable = function(){
			const $form = $('form.variations_form.cart');
			if(!$form.hasClass('cart-centro-select'))
				return;

			const centro = $('#centro_variazione');
			if(!$('#centro_variazione').length)
				return;

			console.log('trigger check_centro_variable');

			const variation = $('input[name="variation_id"]');

			if( centro.val() !== '' && variation.val() !== '0' && variation.val() !== '' )
			{
				console.log('check positivo');
				$form
					.find( '.single_add_to_cart_button' )
					.removeClass( 'disabled wc-variation-selection-needed wc-variation-is-unavailable' );
				$form
					.find( '.woocommerce-variation-add-to-cart' )
					.removeClass( 'woocommerce-variation-add-to-cart-disabled' )
					.addClass( 'woocommerce-variation-add-to-cart-enabled' );
				$form
					.find( '.wl-add-to' )
					.removeClass( 'disabled' );
			}
			else
			{
				console.log('check negativo');
				$form
					.find( '.single_add_to_cart_button' )
					.removeClass( 'wc-variation-is-unavailable' )
					.addClass( 'disabled wc-variation-selection-needed' );
				$form
					.find( '.woocommerce-variation-add-to-cart' )
					.removeClass( 'woocommerce-variation-add-to-cart-enabled' )
					.addClass( 'woocommerce-variation-add-to-cart-disabled' );
				$form
					.find( '.wl-add-to' )
					.addClass( 'disabled' );
			}
		};

		this.bind = function () 
		{
			$( document ).ready( self.boot_ui );
			
			// triggera filtri bundlekit sul link prodotti in lista per aprire dettaglio
			$( document ).on( 'click', '.product-bundlekit-list .tls-btn-add-to-cart-wrapper a', function(e){
				e.preventDefault();
				window.location = $(this).attr('href');
			});
			$( document ).on( 'click', '.product-bundlekit-list', function(e){
				e.preventDefault();
				const formato = $(this).data('formato');
				const durata = $(this).data('durata');

				if($('[data-term-slug="'+formato+'"]') && formato)
					$('[data-term-slug="'+formato+'"]').trigger('click');
				if($('[data-term-slug="'+durata+'"]') && durata)
					$('[data-term-slug="'+durata+'"]').trigger('click');

				$('button.apply-filters').trigger('click');

			});
			
			// Tabs
			$( document ).on( 'init-tabs-bundlekit', '.wc-tabs-wrapper, .woocommerce-tabs', function() {
					$( this ).find( '.wc-tab, .woocommerce-tabs .panel:not(.panel .panel)' ).hide();

					var hash  = window.location.hash;
					var url   = window.location.href;
					var $tabs = $( this ).find( '.wc-tabs, ul.tabs' ).first();

					if ( hash.toLowerCase().indexOf( 'comment-' ) >= 0 || hash === '#reviews' || hash === '#tab-reviews' ) {
						$tabs.find( 'li.reviews_tab a' ).trigger( 'click' );
					} else if ( url.indexOf( 'comment-page-' ) > 0 || url.indexOf( 'cpage=' ) > 0 ) {
						$tabs.find( 'li.reviews_tab a' ).trigger( 'click' );
					} else if ( hash === '#tab-additional_information' ) {
						$tabs.find( 'li.additional_information_tab a' ).trigger( 'click' );
					} else {
						$tabs.find( 'li:first a' ).trigger( 'click' );
					}
				} )
				.on( 'click', '.wc-tabs li a, ul.tabs li a', function( e ) {
					e.preventDefault();
					var $tab          = $( this );
					var $tabs_wrapper = $tab.closest( '.wc-tabs-wrapper, .woocommerce-tabs' );
					var $tabs         = $tabs_wrapper.find( '.wc-tabs, ul.tabs' );

					$tabs.find( 'li' ).removeClass( 'active' );
					$tabs_wrapper.find( '.wc-tab, .panel:not(.panel .panel)' ).hide();

					$tab.closest( 'li' ).addClass( 'active' );
					$tabs_wrapper.find( '#' + $tab.attr( 'href' ).split( '#' )[1] ).show();
				} );

			$(document).on('ready',function () {
				if($('#bundlekit-section')){
					const countb = $('.bundlekit-scheda').data('bundlekit-count');
					if(parseInt(countb)==1){
						// Init Tabs
						$( '.wc-tabs-wrapper, .woocommerce-tabs' ).trigger( 'init-tabs-bundlekit' );
					}
				}
			})
	
			// scroll per prodotti in cat bundlekit
			$(document).on("yith-wcan-ajax-filtered", function(response, filtered){
				// console.log('filtered',filtered);

				const countb = $('.bundlekit-scheda').data('bundlekit-count');
				if(!countb || countb == '')
					return;

				const turl = response.currentTarget.URL;
				if(self.getQueryParams('filter_durata', turl) || self.getQueryParams('filter_formato', turl)){
					if(parseInt(countb)==1){
						// Init Tabs
						$( '.wc-tabs-wrapper, .woocommerce-tabs' ).trigger( 'init-tabs-bundlekit' );
					}

					$('html, body').animate({
						scrollTop: $('ul.products').offset().top-40
					},200);	
					$('[data-carousel]').slick({
						arrows: false,
						dots: true,
						rows: 0,
						responsive: [
						{
							breakpoint: 768,
							settings: {
							slidesToShow: 1
							}
						},
						{
							breakpoint: 1280,
							settings: {
							slidesToShow: 2
							}
						}
						]
					});
				}
			});

			$( document ).on("click", '.product-bundlekit .images a', function(e) {
				e.preventDefault();
			});
			// gestione selezione centro in variante
			$( document ).on('reset_data', self.deselect_centro);
			$( document ).on('ready', self.check_centro_variable);
			$( document ).on('woocommerce_variation_has_changed', self.check_centro_variable);
			// gestion selezione centro in simple
			$( document ).on('ready', self.check_centro_simple);
			$( document ).on('change', '#centro_variazione', self.check_centro_simple);
			$( document ).on('change', '#centro_variazione', self.check_centro_variable);
			// lightbox gallery shortcode
			$( document ).on( 'click', '.gallery-item a', self.initGallery);
			// init mini-cart after ajax product filter
			$( document ).on( 'yith-wcan-ajax-filtered', function(){

				$(document.body).trigger('wc_fragment_refresh');
				location.reload();

			});
		};

		
		this.init = function () {
			
			self.bind();
		};

		this.init();

	};

	(new TLS_Product());

}(window.jQuery, window, document));